import { render, staticRenderFns } from "./ReportProducts.vue?vue&type=template&id=5ac01035&scoped=true"
import script from "./ReportProducts.vue?vue&type=script&lang=js"
export * from "./ReportProducts.vue?vue&type=script&lang=js"
import style0 from "./ReportProducts.vue?vue&type=style&index=0&id=5ac01035&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac01035",
  null
  
)

export default component.exports